import {
   Answer,
   NoAnswersProvidedFault,
   SurveyNotUpdatableFault,
   SurveyUpdateCommand,
} from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { PreInterviewFormBean } from '../form/PreInterviewForm.types';

export type SurveyUpdateActionParameters = {
   surveyId: number;
   answers: PreInterviewFormBean;
};

type SurveyUpdateActionRenderProps = {
   updateSurvey: (parameters: SurveyUpdateActionParameters) => Promise<void>;
};

type SurveyUpdateActionProps = {
   children: (renderProps: SurveyUpdateActionRenderProps) => JSX.Element;
   onSuccess: VoidFunction | PromiseVoidFunction;
   onSurveyNotUpdatableFault: VoidFunction;
};

export const SurveyUpdateAction = (props: SurveyUpdateActionProps): JSX.Element => {
   const { executeAsync: updateSurvey } = useCqrsCommand<
      void,
      SurveyUpdateActionParameters,
      SurveyNotUpdatableFault | NoAnswersProvidedFault
   >(
      (parameters) => {
         const command = new SurveyUpdateCommand();
         command.id = parameters.surveyId;
         command.answers = Object.entries(parameters.answers).reduce<Answer[]>((answers, [questionId, content]) => {
            if (content) {
               answers.push({ questionId: Number(questionId), content: content });
               return answers;
            }
            return answers;
         }, []);

         return command;
      },
      {
         onSuccess: props.onSuccess,
         onFault: {
            'egabinet-survey-frontend-api:SurveyNotUpdatableFault': () => {
               props.onSurveyNotUpdatableFault();
            },
            'egabinet-survey-frontend-api:NoAnswersProvidedFault': () => {
               dispatchSnackbarNegativeEvent(
                  appointmentsTranslationKeys.preInterview.modal.create.form.errors.noAnswersProvidedFault
               );
            },
         },
      }
   );

   return props.children({
      updateSurvey: updateSurvey,
   });
};
